<template>
    <el-dialog :title="i18nConfig(title)" :model-value="open" :draggable="draggable" :width="width" append-to-body
               :append-to="appendTo" :header-class="headerClass" :body-class="bodyClass" :footer-class="footerClass"
               :destroy-on-close="destroyOnClose"
               :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="fullscreen">
      <template #header>
        <slot name="header"></slot>
      </template>
      <template #footer>
        <slot name="footer"></slot>
      </template>
      <slot></slot>
    </el-dialog>
</template>
  
<script>
import { i18nConfig } from '@/utils/ruoyi'
import { ref, reactive } from 'vue';
export default {
    name: "gljy-dialog",
    props: {
        title: String,
        open: Boolean,
        fullscreen: Boolean, // 是否全屏
        headerClass: String,
        bodyClass: String,
        footerClass: String,
        destroyOnClose: Boolean, // 关闭时销毁内部元素
        appendTo: {
            type: String,
            default: "body"
        },
        draggable: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        width: {
            type: [String, Number],
            default: "500px"
        }
    },
    setup() {
        const datas = reactive({
            i18nConfig
        })

        const methods = {

        }


        return {
            ...toRefs(datas),
            ...methods
        }
    }
}
</script>
  
<style></style>